(function(){ 
  $('.addEventCalendar').addToCalendar({
    filename: 'mi-calendario', // filename download for ical excluding extension
    target: '_blank', // specifies the target attribute of the window
    providers: {
      google: 'Google Calendar', // provider name and label
      outlook: 'Outlook Calendar', // provider name and label
      yahoo: 'Yahoo! Calendar', // provider name and label
      other: 'Other Calendar' // other property force download event as .ics for ical
    },
    onAddEvent: function() {} // callback after click provider link
  });
})(); 
